import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import { useState } from 'react'

interface CreateLabelDialogProps {
  open: boolean
  onClose: () => void
  onCreate: (label: string) => void
}

/** Small dialog for naming a new label. Only requires a non-empty name. */
export const CreateLabelDialog = ({ open, onClose, onCreate }: CreateLabelDialogProps): JSX.Element => {
  const [name, setName] = useState('')
  const trimmed = name.trim()

  const handleClose = () => {
    setName('')
    onClose()
  }

  const handleCreate = () => {
    if (!trimmed) return
    onCreate(trimmed)
    setName('')
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Create a new label</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          margin="dense"
          label="Label name"
          value={name}
          onChange={(event) => setName(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') handleCreate()
          }}
          data-testid="new-label-input"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleCreate} disabled={!trimmed} variant="contained">
          Create
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CreateLabelDialog
